import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import nodeinstance from "../../../../../../nodeInstance";

export default function ConfirmPopUp({
  PopUp,
  setYesPopup,
  url,
  callBack,
  dataEmp,
  title,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(false);
  const token = localStorage.getItem("nodeToken");
  const [value, statusValue] = useState();
  const [date, dateSet] = useState();

  const submitHandler = async () => {
    setLoading(true);
    var body =
      dataEmp.qiwa_status !== "Pending"
        ? {
            status: "pending_employee_approval",
            employee_id: dataEmp.employee_id,
            qiwa_status : "qiwa_contract_uploaded"
          }
        : {
            status: value,
            employee_id: dataEmp.employee_id,
            expiry_date: date,
          };
    try {
      const response = await nodeinstance.put(url, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setYesPopup(false);
        callBack();
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "success",
          })
        );
      }
    } catch (err) {
      setError(err);
      setLoading(false);
      console.log("error", err);
    }
  };
  console.log("log to be seen for the page in web")
  return (
    <>
      {dataEmp.qiwa_status !== "Pending" ? (
        <div
          className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
            PopUp ? "flex" : "hidden"
          }`}
        >
          <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
            <div className="flex justify-between items-center w-full">
              <h1
                className="text-md font-semibold cursor-pointer"
                onClick={() => {
                  setYesPopup(false);
                }}
              >
                <IoMdClose />
              </h1>
            </div>
            <div className="w-full">
              <div className="w-full flex flex-col gap-3 my-3 p-5 text-center">
                <div className="form-control w-full text-center gap-2">
                  <span className="label-text  text-xl text-center">
                    {title}
                  </span>

                  <span className="label-text  text-xl text-center">
                    Contract Uploaded
                  </span>
                </div>
                <div
                  className="flex gap-3 w-full justify-center"
                  style={{ margin: 2 }}
                >
                  <button
                    type="submit"
                    className="p-3 bg-green-500 text-white rounded-md w-full max-w-48  my-4 flex  justify-center items-center text-sm"
                    onClick={() => {
                      submitHandler();
                    }}
                  >
                    <p>Proceed </p>
                    {loading ? <CgSpinner className="animate-spin" /> : ""}
                  </button>
                </div>
              </div>
            </div>
            {/* <label>error</label> */}
          </div>
        </div>
      ) : (
        <div
          className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
            PopUp ? "flex" : "hidden"
          }`}
        >
          <div className="max-w-xl w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
            <div className="flex justify-between items-center w-full">
              <h1
                className="text-md font-semibold cursor-pointer"
                onClick={() => {
                  setYesPopup(false);
                }}
              >
                <IoMdClose />
              </h1>
            </div>
            <div className="w-full">
              <div className="w-full flex flex-col gap-3 my-3 p-5 text-center">
                <div className="form-control w-full text-center gap-2">
                  <span className="label-text text-center">
                    Update Qiwa contract status
                  </span>
                  <div className="flex justify-between pt-4">
                    <div className=" text-sm w-auto text-left">
                      <p className="">Employee Id</p>
                      <p className="font-bold">{dataEmp.employee_id}</p>
                    </div>

                    <div className=" text-sm w-auto text-left">
                      <p className="">Employee NAME</p>
                      <p className="font-bold">{dataEmp.employee_name}</p>
                    </div>

                    <div className=" text-sm w-auto text-left">
                      <p className="">IQAMA Number</p>
                      <p className="font-bold">{dataEmp.iqama_number}</p>
                    </div>
                  </div>
                  <div className="flex justify-between pt-4 ">
                    <div className=" text-sm w-auto text-left">
                      <p className="pb-2">Qiwa contract status</p>
                      <select
                        className="input input-xl h-10 max-w-48 input-bordered focus:outline-none uppercase"
                        value={value}
                        defaultValue={{ label: "Choose", value: "placeholder" }}
                        onChange={(e) => {
                          statusValue(e.target.value);
                        }}
                      >
                        <option value="placeholder" hidden>
                          Choose
                        </option>
                        {[{ value: "Active" }, { value: "PENDING" }].map(
                          (value) => (
                            <option key={value.value} value={value.value}>
                              {value.value}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    <div className=" text-sm w-auto text-left">
                      <p className="pb-2">Expiry Date</p>
                      <input
                        type="date" // Change input type to text
                        id="field2"
                        className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                        required
                        onChange={(e) => dateSet(e.target.value)}
                      />
                    </div>

                    <div className="text-sm w-auto text-left pt-3">
                      <button
                        type="button"
                        className="p-2 bg-green-500 text-white rounded-md w-full max-w-48  my-4 flex  justify-center items-center text-sm"
                        onClick={() => {
                          submitHandler();
                        }}
                      >
                        <p>update </p>
                        {loading ? <CgSpinner className="animate-spin" /> : ""}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
